import { Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { ReactElement, ReactNode } from 'react';
import classes from './TimelineHeader.module.css';

type TimelineHeaderAddMenuProps = {
  children: ReactNode;
};

/**
 * Shared "+ Add" menu shell for patient and partner timeline headers.
 * Pass `Menu.Item` (or custom rows) as children.
 */
export default function TimelineHeaderAddMenu({ children }: TimelineHeaderAddMenuProps): ReactElement {
  return (
    <Menu shadow="md" width={200} position="bottom-end">
      <Menu.Target>
        <UnstyledButton className={`${classes.actionGroup} ${classes.actionButton} ${classes.actionItem}`} c="#246A7A">
          <Group gap="5px" style={{ cursor: 'pointer' }}>
            <IconPlus size={18} />
            <Text fw={600} ml="5px">
              Add
            </Text>
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown className={classes.menuDropdown} style={{ maxWidth: '180px' }}>
        {children}
      </Menu.Dropdown>
    </Menu>
  );
}
